import Session, { IS_BUYSIDE } from '../../../../common/services/Session';

const isBuySide = Session.get(IS_BUYSIDE);

export const FILTERS_INITIAL_STATE = {
  investor: [],
  product: [],
  special: [],
  term: 'All',
  flagged: true,
  exceptionsApplied: false,
  ...(isBuySide && { lockPeriod: [] }),
};
